import React from "react";
import IndexCallClaim from "./indexCallClaim";
import IndexCallReservation from "./indexCallReservation";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { sendAPIRequest } from "shared/utils/requests";
const moment = require("moment");

export default class CallReservationModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lengthLower: 5,
      lengthUpper: 15,
      AMRLower: 0.10,
      AMRUpper: 0.30,
      isASAP: true,
      timeWindowLower: moment(),
      timeWindowUpper: moment().add(30, "m"),
      claimsAvailable: Infinity,
      reserving: true,
      data: {},
    };

    this.onChange = this.onChange.bind(this);
    this.onTimeWindowChange = this.onTimeWindowChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    setInterval(() => {
      sendAPIRequest("/call_reservations", "GET").then(response => {
        this.setState({
          data: response.data,
          reserving: false,
        });
      });
    }, 5000);
  }

  onChange(e) {
    if (e.target.name === "isASAP") {
      this.setState({
        [e.target.name]: e.target.checked,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  }

  onTimeWindowChange(windowType, moment) {
    this.setState({
      [windowType]: moment,
    });
  }

  onSubmit() {
    let {
      lengthLower,
      lengthUpper,
      AMRLower,
      AMRUpper,
      isASAP,
      timeWindowLower,
      timeWindowUpper,
      data,
    } = this.state;

    this.setState({ reserving: true }, async () => {
      const unconfirmedReservations = data.unconfirmed_reservations || [];
      const reservedCall =
        unconfirmedReservations.length > 0
          ? unconfirmedReservations[0]
          : undefined;

      if (isASAP) {
        if (!reservedCall) {
          timeWindowLower = moment();
          timeWindowUpper = moment().add(30, "m");
        } else {
          timeWindowLower = moment(reservedCall.datetime_seek_max).add(5, "m");
          timeWindowUpper = moment(reservedCall.datetime_seek_max).add(35, "m");
        }
      }

      await sendAPIRequest("/call_reservations", "POST", {
        call_length_seconds_range: [lengthLower * 60, lengthUpper * 60],
        audio_minute_dollars_rate_range: [AMRLower, AMRUpper],
        datetime_seek_range: [timeWindowLower, timeWindowUpper],
      });
    });
  }

  async onCancel() {
    let { data } = this.state;
    let pendingReservations = data.pending_reservations || [];
    if (pendingReservations.length > 0) {
      await sendAPIRequest(
        `/call_reservations/${pendingReservations[0].id}`,
        "DELETE"
      );
    }
  }

  render() {
    let {
      lengthLower,
      lengthUpper,
      AMRLower,
      AMRUpper,
      isASAP,
      timeWindowLower,
      timeWindowUpper,
      claimsAvailable,
      reserving,
      data,
    } = this.state;

    let { claimCall, currentlyEditing } = this.props;

    return (
      <Row>
        <Col xs={12} md={7}>
          <IndexCallReservation
            lengthLower={lengthLower}
            lengthUpper={lengthUpper}
            AMRLower={AMRLower}
            AMRUpper={AMRUpper}
            isASAP={isASAP}
            timeWindowLower={timeWindowLower}
            timeWindowUpper={timeWindowUpper}
            claimsAvailable={claimsAvailable}
            reserving={reserving}
            data={data}
            onChange={this.onChange}
            onTimeWindowChange={this.onTimeWindowChange}
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
          />
        </Col>
        <Col xs={12} md={5}>
          <IndexCallClaim
            data={data}
            claimCall={claimCall}
            currentlyEditing={currentlyEditing}
          />
        </Col>
      </Row>
    );
  }
}
